module.exports = __webpack_public_path__ + "static/media/prick_HMPG_survey_image_600M.c21821b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/prick_HMPG_survey_image_600M.jpg
// module id = 357
// module chunks = 0